import React, { createContext, useContext, useEffect, useState } from 'react'
import { ApiServiceContext, ToastContext } from '../../utils/shared.module'
import { email, end_points } from '../../services/core.index'
import * as yup from 'yup'
import { useDispatch, useSelector } from 'react-redux'
import { RootReduxProps } from '../../store/reduxInterface'
import LayoutSettings from '../../pages/feature/settings/layoutSettings'
import { setlayoutsettings } from '../../store/layoutsettingsSlice'

const layoutsFormSchema = yup.object({
  administration_email: yup
    .string()
    .label('Admin Email')
    .required()
    .matches(email, 'Enter a valid email address')
    .nullable()
    .max(64)
    .trim(),
  recaptcha_secret_key: yup
    .string()
    .label('Recaptcha secret key')
    .required()
    .nullable()
    .max(100)
    .trim(),
  recaptcha_site_key: yup
    .string()
    .label('Recaptcha Site key')
    .required()
    .nullable()
    .max(100)
    .trim(),
  application_title: yup
    .string()
    .label('Application title')
    .required()
    .nullable()
    .max(100)
    .trim(),
  site_address: yup
    .string()
    .label('Site address')
    .required()
    .nullable()
    .max(100)
    .trim(),
  primary_color: yup.string().nullable().max(7).trim(),
  secondary_color: yup.string().nullable().max(7).trim(),
  // google_recaptcha: yup.object().shape({
  //   value: yup.string().required('Choose layouts Mode'),
  // }),
  google_recaptcha: yup.object().shape({
    value: yup.string().required('Choose layouts Mode'),
  }),
  site_title: yup.string().label('Site title').required(),
  // login_background_image: yup
  //   .mixed()
  //   .required('Required')
  //   .nullable()
  //   .test('is-valid-type', 'Not a valid image type', (value: any) => {
  //     if (value.length == 0) return false
  //     return isValidFileType(value && value[0]?.name?.toLowerCase(), 'image')
  //   })
  //   .test('is-valid-size', 'Max allowed size is 100KB', (value: any) => {
  //     return value && value[0]?.size <= 102400
  //   }),
  // // logo: yup.mixed().nullable(),
  // logo: yup
  //   .mixed()
  //   .required('Required')
  //   .nullable()
  //   .test('is-valid-type', 'Not a valid image type', (value: any) => {
  //     if (value.length == 0) return false
  //     return isValidFileType(value && value[0]?.name?.toLowerCase(), 'image')
  //   })
  //   .test('is-valid-size', 'Max allowed size is 100KB', (value: any) => {
  //     return value && value[0]?.size <= 102400
  //   }),
  // loading_animation: yup
  //   .mixed()
  //   .required('Required')
  //   .nullable()
  //   .test('is-valid-type', 'Not a valid image type', (value: any) => {
  //     if (value.length == 0) return false
  //     return isValidFileType(value && value[0]?.name?.toLowerCase(), 'image')
  //   })
  //   .test('is-valid-size', 'Max allowed size is 100KB', (value: any) => {
  //     return value && value[0]?.size <= 102400
  //   }),
  // favicon: yup
  //   .mixed()
  //   .required('Required')
  //   .nullable()
  //   .test('is-valid-type', 'Not a valid image type', (value: any) => {
  //     if (value.length == 0) return false
  //     return isValidFileType(value && value[0]?.name?.toLowerCase(), 'image')
  //   })
  //   .test('is-valid-size', 'Max allowed size is 100KB', (value: any) => {
  //     return value && value[0]?.size <= 102400
  //   }),
})

const validFileExtensions: any = {
  image: ['jpg', 'png', 'jpeg', 'svg'],
}

function isValidFileType(fileName: any, fileType: any) {
  return (
    fileName &&
    validFileExtensions[fileType].indexOf(fileName.split('.').pop()) > -1
  )
}

export const LayoutsContext = createContext({
  submitlayoutsForm: (data: any) => {},
  layoutsFormSchema: layoutsFormSchema,
  errorMessage: '',
  loading: false,
  getLayoutData: {},
})

const LayoutsComponentController = (props: any) => {
  const { postData, getData } = useContext(ApiServiceContext)
  const [errorMessage, setErrorMessage] = useState<string>('')
  const [getLayoutData, setGetLayoutData] = useState<any>({})
  const [loading, setLoading] = useState<boolean>(false)
  const dispatch = useDispatch()
  const {
    showSuccess,
    showInfo,
    showWarn,
    showError,
    showSecondary,
    showContrast,
  } = useContext(ToastContext)

  const submitlayoutsForm = async (data: any) => {
    const formData = new FormData()
    formData.append(`administration_email`, data?.administration_email)
    formData.append(`google_recaptcha`, data?.google_recaptcha.value)
    formData.append(`application_title`, data?.application_title)
    formData.append(`primary_color`, data?.primary_color)
    formData.append(`recaptcha_secret_key`, data?.recaptcha_secret_key)
    formData.append(`recaptcha_site_key`, data?.recaptcha_site_key)
    formData.append(`secondary_color`, data?.secondary_color)
    formData.append(`site_address`, data?.site_address)
    formData.append(`site_title`, data?.site_title)
    formData.append(`favicon`, data?.favicon[0] || '')
    formData.append(`loading_animation`, data?.loading_animation[0] || '')
    formData.append(
      `login_background_image`,
      data?.login_background_image[0] || '',
    )
    formData.append(`logo`, data?.logo[0] || '')

    setErrorMessage('')
    setLoading(true)
    try {
      const response = await postData(end_points.layoutsAdd.url, formData)
      setLoading(false)
      if (response.status === 200) {
        getlayoutsForm()
        const userDetails = response.data.data
      } else {
        setErrorMessage(response.data.message)
      }
      return response
    } catch (error) {
      setErrorMessage('Unable to proceed layouts')
    }
  }

  const getlayoutsForm = async () => {
    getData(end_points.layoutsGet.url).then((value: any) => {
      dispatch(setlayoutsettings(value?.data?.data))
    })
  }

  useEffect(() => {
    getlayoutsForm()
  }, [])

  return (
    <LayoutsContext.Provider
      value={{
        submitlayoutsForm,
        layoutsFormSchema,
        errorMessage,
        loading,
        getLayoutData,
      }}
    >
      {props.children}
    </LayoutsContext.Provider>
  )
}

const LayoutsComponent = () => {
  return (
    <>
      <LayoutsComponentController>
        <LayoutSettings />
      </LayoutsComponentController>
    </>
  )
}
export default LayoutsComponent
